import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  BACKGROUND_COLOR,
  PRIMARY_COLOR,
  PRIMARY_TEXT_COLOR,
} from '../../constants';
import TopBarInLandingPage from '../../components/common/TopBar/TopBarInLandingPage';
import { desktopMediaQuery } from '../../styleHelpers';
import { seoPages } from './featurePagesContent';
import { FaArrowRight } from 'react-icons/fa6';
import { HOME_PATH } from '../../pathNames';

const FeaturesPage: React.FC = () => {
  // features/:slug is SEODetail
  return (
    <Container>
      <TopBarInLandingPage />
      <TopPartContainer>
        <Title>Features</Title>
        <GoToGeneratorLink to={HOME_PATH}>
          Go to AI Image Generator and Chat <FaArrowRight />
        </GoToGeneratorLink>
      </TopPartContainer>
      <FeaturesList>
        {seoPages.map((page) => (
          <FeatureCardLink key={page.slug} to={`/features/${page.slug}`}>
            <FeatureImage src={page.content[0].src} alt={page.title} />
            <FeatureContent>
              <FeatureTitle>{page.title}</FeatureTitle>
              <FeatureDescription>{page.description}</FeatureDescription>
              <ReadMoreButton>
                Read more <FaArrowRight size={12} />
              </ReadMoreButton>
            </FeatureContent>
          </FeatureCardLink>
        ))}
      </FeaturesList>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${BACKGROUND_COLOR};
  padding: 20px;
  min-height: 100vh;
`;

const TopPartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 64px;
`;

const Title = styled.h1`
  color: ${PRIMARY_TEXT_COLOR};
  text-align: center;
  margin-bottom: 40px;
`;

const GoToGeneratorLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 36px;
  padding: 8px 12px;
  font-size: 16px;
  gap: 8px;
  width: 100%;
  border: 2px solid ${PRIMARY_COLOR};
  border-radius: 8px;
  color: ${PRIMARY_TEXT_COLOR};
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }

  ${desktopMediaQuery} {
    max-width: 500px;
    font-size: 20px;
    padding: 12px;
  }
`;

const FeaturesList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;

  ${desktopMediaQuery} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const FeatureCardLink = styled(Link)`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.2s ease-in-out;
  width: 100%;
  

  ${desktopMediaQuery} {
    max-width: 400px;
  }

  &:hover {
    transform: translateY(-4px);
  }
`;

const FeatureImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: top;
`;

const FeatureContent = styled.div`
  padding: 20px;
`;

const FeatureTitle = styled.h2`
  color: ${PRIMARY_TEXT_COLOR};
  margin-bottom: 12px;
  font-size: 20px;
`;

const FeatureDescription = styled.p`
  color: ${PRIMARY_TEXT_COLOR}cc;
  font-size: 16px;
  line-height: 1.5;
`;

const ReadMoreButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${PRIMARY_COLOR};
  font-size: 14px;
  margin-top: 16px;
  font-weight: 500;

  &:hover {
    opacity: 0.8;
  }
`;

export default FeaturesPage;
